export const isAndroid = () => {
  return /android/i.test(navigator.userAgent)
}